/*
 * @Description: 统一接口地址配置
 * @Author: zhanjunwei
 * @Date: 2024-12-06 11:10:04
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-01-13 16:28:29
 */
// 接口前缀
const apiPrefix = '/openTechPortalWebAPI/techforgood';

export default {
  // 用户信息url
  userinfoApi: apiPrefix + '/usercenter/current/user/detail',
  // 退出登录
  logoutApi: '/api/user/SSVOPEN/logout',
  // 获取省市区
  getDistrictApi: '/opentechapi/portal/district/list',
  // 获取团队名称
  getTeamNameApi: '/ssvopenPortalWebAPI/team/getTeamName',
  // 验证是否申领
  getApplyCheckApi: '/ssvopenPortalWebAPI/toolapply/check',
};
